import React, { Component } from 'react';
import Responsive from '../Responsive';

class PieChartSkeleton extends Component {
    state = {
        dot: [
            { bg: "#dedede", width: "24%" },
            { bg: "#efefef", width: "35%" },
            { bg: "#c6c6c6", width: "25%" },
            { bg: "#8a8a8a", width: "28%" },
        ]
    }
    render() {
        const chartStyle = {
            width: '180px',
            height: '180px',
            position: 'relative',
        };

        const sliceStyle = {
            position: 'absolute',
            width: '100%',
            height: '100%',
            clipPath: 'polygon(50% 50%, 100% 0, 100% 100%)',
        };

        const slice1Style = {
            ...sliceStyle,
            backgroundColor: '#dedede',
            transform: 'rotate(0deg)',
            borderRadius: '50%'

        };

        const slice2Style = {
            ...sliceStyle,
            backgroundColor: '#c6c6c6',
            transform: 'rotate(45deg)',
            borderRadius: '50%'

        };

        const slice3Style = {
            ...sliceStyle,
            backgroundColor: '#8a8a8a',
            transform: 'rotate(135deg)',
            borderRadius: '50%'

        };

        const slice4Style = {
            ...sliceStyle,
            backgroundColor: '#efefef',
            transform: 'rotate(180deg)',
            borderRadius: '50%'

        };

        return (
            <div className='dashboard-widgets p-3 w-100'>
                <p className='' style={{color:'#cdcdcd',fontWeight:700}}>Log in and Create Widgets</p>
                {/* <div className='br-15 mt-1' style={{ width: '20%', height: 18, backgroundColor: '#dedede' }}></div> */}
                <div className='br-15 mt-2' style={{ width: '100%', height: 18, backgroundColor: '#dedede' }}></div>
                <div className='br-15 mt-2' style={{ width: '70%', height: 18, backgroundColor: '#dedede' }}></div>
                <div className='flexcc w-100'>
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', sm: '12', md: '6', lg: '6' }}>
                        <div className='position-relative mld-3' style={chartStyle}>
                            <div className='position-absolute' style={{ width: 105, height: 105, backgroundColor: '#fff', borderRadius: "50%", top: "22%", left: "21%", zIndex: 1 }}></div>
                            <div style={slice1Style}></div>
                            <div style={slice2Style}></div>
                            <div style={slice3Style}></div>
                            <div style={slice2Style}></div>
                            <div style={slice4Style}></div>
                        </div>
                    </Responsive>
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', sm: '12', md: '6', lg: '6' }}>

                        <div className='mld-5 '>
                            {this.state.dot.map((item, index) => {
                                return (
                                    <div key={index} className='flexc w-100 mt-2'>
                                        <div className='skeleton-box br-15 ' style={{ width: 20, height: 20, backgroundColor: (item.bg) }}></div>
                                        <div className=' br-15 mx-2' style={{ width: (item.width), height: 20, backgroundColor: (item.bg) }}></div>
                                    </div>
                                )
                            })}
                        </div>
                    </Responsive>

                </div>
            </div>
        )
    }
}

export default PieChartSkeleton;